import {
  CreateDamageDto,
  DamageFilterDto,
  DeleteDamageDto,
  IAgency,
  IDamage,
  IDamageStep,
  IFile,
  ITask,
  MoveDamageDto,
  UpdateDamageDto,
  UpdateDamageOrderDto,
} from 'admiral-core';
import { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';

export class DamageApi {
  static getDamages(filter: DamageFilterDto): Promise<AxiosResponse<IDamage[]>> {
    return AdmiralApi.apiCall<IDamage[]>({
      method: 'POST',
      url: `${BASE_URL}/damage/list`,
      data: filter,
    });
  }

  static getArchivedDamages(showDemo?: boolean): Promise<AxiosResponse<IDamage[]>> {
    return AdmiralApi.apiCall<IDamage[]>({
      method: 'POST',
      url: `${BASE_URL}/damage/archived`,
      data: { showDemo },
    });
  }

  static archiveDamage(id: string): Promise<AxiosResponse<IDamage>> {
    return AdmiralApi.apiCall<IDamage>({
      method: 'PATCH',
      url: `${BASE_URL}/damage/${id}/archive`,
    });
  }

  static dearchiveDamage(id: string): Promise<AxiosResponse<IDamage>> {
    return AdmiralApi.apiCall<IDamage>({
      method: 'PATCH',
      url: `${BASE_URL}/damage/${id}/dearchive`,
    });
  }

  static getDamage(id: string): Promise<AxiosResponse<IDamage>> {
    return AdmiralApi.apiCall<IDamage>({
      method: 'POST',
      url: `${BASE_URL}/damage/get`,
      data: { id },
    });
  }

  static getDamageSteps(damageId: string): Promise<AxiosResponse<IDamageStep[]>> {
    return AdmiralApi.apiCall<IDamageStep[]>({
      method: 'POST',
      url: `${BASE_URL}/damage/get/steps`,
      data: { damageId },
    });
  }

  static getTasks(damageId: string): Promise<AxiosResponse<ITask[]>> {
    return AdmiralApi.apiCall<ITask[]>({
      method: 'POST',
      url: `${BASE_URL}/damage/get/tasks`,
      data: { damageId },
    });
  }

  static create(createDamageDto: CreateDamageDto): Promise<AxiosResponse<IDamage>> {
    const formData = new FormData();
    formData.append('body', JSON.stringify(createDamageDto));
    createDamageDto.newUploadedFiles?.forEach((file) => formData.append('files', file));

    return AdmiralApi.apiCall<IDamage>({
      method: 'POST',
      url: `${BASE_URL}/damage/create`,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  static update(id: string, updateDamageDto: UpdateDamageDto): Promise<AxiosResponse<IDamage>> {
    const formData = new FormData();
    formData.append('body', JSON.stringify(updateDamageDto));
    updateDamageDto.newUploadedFiles?.forEach((file) => formData.append('files', file));

    return AdmiralApi.apiCall<IDamage>({
      method: 'PATCH',
      url: `${BASE_URL}/damage/${id}`,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  static delete(id: string, deleteDamageDto: DeleteDamageDto): Promise<AxiosResponse<void>> {
    return AdmiralApi.apiCall<void>({
      method: 'DELETE',
      url: `${BASE_URL}/damage/${id}`,
      data: deleteDamageDto,
    });
  }

  static updateDamageOrder(dto: UpdateDamageOrderDto): Promise<AxiosResponse<IDamage[]>> {
    return AdmiralApi.apiCall<IDamage[]>({
      method: 'POST',
      url: `${BASE_URL}/damage/order`,
      data: dto,
    });
  }

  static move(id: string, dto: MoveDamageDto): Promise<AxiosResponse<IDamage>> {
    return AdmiralApi.apiCall<IDamage>({
      method: 'PATCH',
      url: `${BASE_URL}/damage/${id}/move`,
      data: dto,
    });
  }

  static getDamagesCustomerNames(agency: IAgency): Promise<AxiosResponse<string[]>> {
    return AdmiralApi.apiCall<string[]>({
      method: 'POST',
      url: `${BASE_URL}/damage/customer-names`,
      data: { agency },
    });
  }

  static validate(id: string): Promise<AxiosResponse<void>> {
    return AdmiralApi.apiCall<void>({
      method: 'POST',
      url: `${BASE_URL}/damage/${id}/validate`,
    });
  }
  static getFiles(damageId: string): Promise<AxiosResponse<IFile[]>> {
    return AdmiralApi.apiCall<IFile[]>({
      method: 'POST',
      url: `${BASE_URL}/damage/get/files`,
      data: { damageId },
    });
  }
}
